import { Tag } from 'antd';
import React from 'react'
import { CloseCircleOutlined, CheckCircleOutlined, InfoCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons'


export default function getCharacterStatus(character) {
    if(character === undefined || character === null) {
        return null;
    }
    switch(character.characterStatus?.name) {
        case "Dead":
          return (
            <Tag color="purple">
                {character.characterStatus?.name}
            </Tag>
          )
          case "Rejected":
            return (
              <Tag icon={<CloseCircleOutlined />} color="error">
                  {character.characterStatus?.name}
              </Tag>
            )
          case "Accepted by SL":
            return (
              <Tag icon={<CheckCircleOutlined />} color="success">
                  {character.characterStatus?.name}
              </Tag>
            )
          case "Review for SL":
            return (
              <Tag 
                icon={<ExclamationCircleOutlined />} 
                color="warning"
             >
                  {character.characterStatus?.name}
              </Tag>
            )
          case "Changed after Accepted":
              return (
                  <Tag icon={<InfoCircleOutlined />} color="default">
                      {character.characterStatus?.name}
                  </Tag>
              )
          default:
            return null;
      }
    
}